import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import SectionHeader from "@quest_editor/components/SectionHeader";
import InfoSection from "@quest_editor/components/InfoSection";
import QuestClearedField from "./QuestClearedField";
import QuestUnclearedField from "./QuestUnclearedField";
import QuestUnparticipatedField from "./QuestUnparticipatedField";

const QuestConditionSection = ({
  expanded,
  onExpandedChange,
  clearedQuestId,
  setClearedQuestId,
  unclearedQuestId,
  setUnclearedQuestId,
  unparticipatedQuestId,
  setUnparticipatedQuestId,
}: {
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  clearedQuestId: string;
  setClearedQuestId: (v: string) => void;
  unclearedQuestId: string;
  setUnclearedQuestId: (v: string) => void;
  unparticipatedQuestId: string;
  setUnparticipatedQuestId: (v: string) => void;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, exp) => onExpandedChange(exp)}
      elevation={0}
      disableGutters
      sx={{
        border: 1,
        borderColor: "divider",
        "&:before": { display: "none" },
        ".MuiAccordionSummary-root .MuiSvgIcon-root": {
          transform: "rotate(0deg)",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "primary.contrastText" }} />}
        sx={{
          p: 0,
          minHeight: "unset",
          bgcolor: "primary.main",
          "&.Mui-expanded": { minHeight: "unset" },
          "& .MuiAccordionSummary-content": { m: 0, flexGrow: 1 },
          "& .MuiAccordionSummary-expandIconWrapper": {
            position: "absolute",
            right: 16,
          },
        }}
      >
        <SectionHeader title={t("quest_edit_target.section.quest")} />
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <InfoSection
          rows={[
            {
              label: t("quest_edit_target.field.quest.cleared.name"),
              children: (
                <QuestClearedField
                  value={clearedQuestId}
                  onChange={setClearedQuestId}
                />
              ),
            },
            {
              label: t("quest_edit_target.field.quest.uncleared.name"),
              children: (
                <QuestUnclearedField
                  value={unclearedQuestId}
                  onChange={setUnclearedQuestId}
                />
              ),
            },
            {
              label: t("quest_edit_target.field.quest.unparticipated.name"),
              children: (
                <Stack direction="column" spacing={1}>
                  <QuestUnparticipatedField
                    value={unparticipatedQuestId}
                    onChange={setUnparticipatedQuestId}
                  />
                </Stack>
              ),
            },
          ]}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default QuestConditionSection;
